import { lighten } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { lightTheme } from '@gojitsu/web-ui-core';

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    marginTop: 30,
  },
  main: {
    minHeight: 500,
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    border: '1px solid #e0e0eb',
  },
  table: {
    minWidth: 750,
    '& tr th:nth-of-type(-n+2)': {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
    },
    '& tbody td:first-of-type': {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
      color: '#7e7d7e',
    },
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    marginBottom: '10px',
  },
  cellOnClick: {
    '&>a': {
      color: '#4a90e2',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  searchBtn: {
    backgroundColor: '#75c31e',
  },
  chatMessages: {
    maxHeight: 350,
    overflowY: 'scroll',
  },
  title: {
    borderBottom: '1px solid rgba(0,0,0,.125)',
    padding: 0,
    margin: 0,
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 20,
  },
  reasonSection: {
    padding: '0px 20px',
    height: '100%',
    '& .status': {
      fontSize: '0.6em',
      boxShadow: 'none',
      position: 'relative',
      top: '-20px',
    },
    '& .approved': {
      backgroundColor: '#4caf50',
      color: '#fff',
    },
    '& .rejected': {
      backgroundColor: '#b2102f',
      color: '#fff',
    },
    '& .in_progress': {
      backgroundColor: '#ffc107',
      color: '#fff',
    },
    '& svg': {
      position: 'relative',
      top: 5,
    },
    '& .direct-chat-name': {
      fontWeight: 600,
      fontSize: '0.88em',
    },
    '& .direct-chat-timestamp': {
      color: '#999',
      fontSize: '0.88em',
    },
    '& .direct-chat-text': {
      borderRadius: 5,
      position: 'relative',
      padding: '5px 10px',
      background: '#d2d6de',
      border: '1px solid #d2d6de',
      margin: '5px 0 0 50px',
      color: '#444',
    },
    '& .right>.direct-chat-text': {
      background: '#3c8dbc',
      borderColor: '#3c8dbc',
      color: '#fff',
    },
    '& .pull-right': {
      float: 'right',
    },
    '& .pull-left': {
      float: 'left',
    },
    '& .direct-chat-img': {
      borderRadius: '50%',
      float: 'left',
      width: '40px',
      height: '40px',
    },
    '& .right .direct-chat-img': {
      float: 'right',
    },
    '& .right .direct-chat-text': {
      marginRight: 50,
      marginLeft: 0,
    },
    '& .direct-chat-messages': {
      paddingTop: 20,
    },
    '& .direct-chat-msg': {
      margin: '30px 0px',
    },
    '& .box-footer': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomRightRadius: '3px',
      borderBottomLeftRadius: '3px',
      borderTop: '1px solid #f4f4f4',
      padding: '10px 0px',
      backgroundColor: '#fff',
      marginTop: 45,
    },
    '& button': {
      marginRight: 15,
      marginTop: 15,
      padding: '6px 30px',
    },
    '& .input-group': {
      display: 'flex',
      flexDirection: 'row',
    },
    '& .input-group-btn': {
      width: '100%',
    },
    '& .clearfix': {
      clear: 'both',
    },
    '& .direct-chat-infos': {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
    },
    '& button[disabled]': {
      opacity: 0.7,
      color: '#fff',
    },
    '& .file': {
      marginLeft: 15,
    },
  },
  close: {
    display: 'flex',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    background: '#fff',
    position: 'absolute',
    right: '10px',
    top: '10px',
    zIndex: '99999',
    color: '#000',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px solid #000',
    cursor: 'pointer',
  },
  answerInput: {
    width: '98%',
    padding: 10,
  },
  reason: {
    border: '1px solid #efe8e8',
    background: '#efe8e8',
    padding: 15,
    borderRadius: 10,
    textAlign: 'justify',
  },
  row: {
    marginTop: 16,
    '& label': {
      fontWeight: 700,
    },
  },
  driverInfos: {
    textAlign: 'center',
    height: '100%',
    '& img': {
      width: 220,
      height: 220,
      borderRadius: 220,
    },
  },
  driverName: {
    fontWeight: 700,
    color: theme.palette.secondary.main,
    fontSize: '1.4em',
  },
  btnReject: {
    borderColor: '#f50057',
    backgroundColor: '#ab003c !important',
    color: '#fff',
  },
  btnApprove: {
    borderColor: '#357a38',
    backgroundColor: '#4caf50 !important',
    color: '#fff',
  },
  btnPrimary: {
    backgroundColor: '#3c8dbc !important',
    color: '#fff',
  },
  error: {
    color: '#ab003c',
  },
  termination: {
    padding: '0px 20px',
    height: '100%',
    '& h3': {
      paddingBottom: 20,
    },
  },
  closeIcon: {
    padding: 8,
  },
  commentFiles: {
    '& .file:first-of-type': {
      marginLeft: 0,
    },
  },
  indicator: {
    color: '#fff',
    backgroundColor: lightTheme.palette.secondary.main,
    padding: '0px 10px',
    borderRadius: '8px',
    fontWeight: 400,
    fontSize: '0.9em',
  },
  contentBold: {
    fontWeight: 700,
  },
  content: {
    maxWidth: 400,
  },
}));

export default useStyles;
